const closeAlert = document.querySelector(".alert-banner__close");
const banner = document.querySelector(".alert");
const header = document.querySelector(".navbar-one__desktop");
const nav_menu = document.querySelector(
  ".navbar-one__mobile .menu-primary-navigation-container .navbar-one__menu"
);

const nav_menu_inner = document.querySelectorAll(
  "#menu-primary-navigation-1 .sub-menu"
);

if (banner) {
  // Check for cookie immediately on page load
  if (document.cookie.indexOf("alertbarDismissed=true") > -1) {
    //handle floating header when alert bar is NOT showing
   nav_menu.style.paddingTop = (((header.offsetHeight) + 30) + "px")
   nav_menu_inner .forEach(sub_menu => {
    sub_menu.style.paddingTop = (((header.offsetHeight) + 30) + "px")
  });
  }


  //handle floating header if alert bar is showing.
  else { 
    // Hide announcement bar
    banner.style.display = "block";

    nav_menu.style.paddingTop = (((header.offsetHeight) + 30) + "px")

    nav_menu_inner .forEach(sub_menu => {
      sub_menu.style.paddingTop = (((header.offsetHeight) + 30) + "px")
    });
  }


  closeAlert.addEventListener("click", () => {
    banner.style.maxHeight = "0vh";
    banner.style.opacity = "0";
    banner.style.visibility = "hidden";

    // Set cookie with expiration date
    document.cookie =
      "alertbarDismissed=true; expires=" +
      new Date(new Date().getTime() + 24 * 60 * 60 * 1000).toUTCString() +
      "; path=/";
  });
}
